import * as actions from './actions';


export default (state = {}, action) => {
  switch (action.type) {
    case actions.INIT.COMPANY.BEGIN:
      return {
        ...state,
        companyOptions: [{ title: 'loading...' }],
      };
    case actions.INIT.COMPANY.END:
      return {
        ...state,
        companyOptions: action.companyOptions,
        selectedCompany: action.companyOptions.filter(x => x.id == (state.template ? state.template.presetCompanyId : state.companyId))[0]
      };
    case actions.SET_COMPANY.BEGIN:
      return {
        ...state,
        companyId: action.companyId,
      };
    case actions.SET_COMPANY.END:
      return {
        ...state,
        workingTimings: action.workingTimings,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/creator/reducer.js